<template>
<div class="comline chartConfig_viewDP">
         <div class="chartDivConfig colViewConfig">
            <span class="span_til">线颜色</span>
            <el-color-picker v-model="config.lines.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">线宽</span>
            <el-input v-model="config.lines.lineStyle.width" @change="getRender" type="number" ></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">线的类型</span>
            <el-select v-model="config.lines.lineStyle.type" placeholder="请选择标记的图形"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in lineList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">边的曲度</span>
            <el-input v-model="config.lines.lineStyle.curveness" @change="getRender" type="number" step="0.1" min="0" max="1"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.lines.effect.show" @change="getRender">是否显示特效</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">动画时间</span>
            <el-input v-model="config.lines.effect.period" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">s</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">特效标记</span>
            <el-select v-model="config.lines.effect.symbol" placeholder="请选择标记的图形"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in symbolList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">标记大小</span>
            <el-input v-model="config.lines.effect.symbolSize" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">标记颜色</span>
            <el-color-picker v-model="config.lines.effect.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig">
            <span class="span_til">尾迹长度</span>
            <el-input v-model="config.lines.effect.trailLength" @change="getRender" type="number" step="0.1" min="0" max="1"></el-input>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.lines.effect.loop" @change="getRender">是否循环显示特效</el-checkbox>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'line_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                symbolList: [
                    {value: 'circle', label: '圆'},
                    {value: 'rect', label: '矩型'},
                    {value: 'roundRect', label: '圆矩型'},
                    {value: 'pin', label: '标记'},
                    {value: 'arrow', label: '箭头'},
                    {value: 'none', label: '空'},
                    {value: 'triangle', label: '三角形'},
                    {value: 'emptyCircle', label: '空心圆'},
                    {value: 'diamond', label: '菱形'}
                ],
                lineList:[
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .line_config {

    }
</style>